import React from 'react';
import autoBind from 'react-autobind';
import DeckGL from "deck.gl";
import {WebMercatorViewport} from 'deck.gl';
import {GeoJsonLayer, IconLayer, TripsLayer} from 'deck.gl'
import Map from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";

import Config from "../../Config.jsx";
import Localization from "../../Localization.jsx"

import ButtonGroup from '@mui/material/ButtonGroup';

import startFlag from "../../images/flags/start.png";
import endFlag from "../../images/flags/end.png";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Card,
  CardContent,
  Divider,
  Typography,
  Grid,
} from '@mui/material';
import { withTheme } from '@mui/styles';

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Rectangle,
  Polyline,
} from "react-google-maps";

const {KalmanFilter} = require('kalman-filter');

class SubmissionDetailMapDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      open: false,
      localeCenter: {
        lat: 22.4191,
        lng: 114.2059,
      },
      localeUpperLeft: {
        lat: 22.4299,
        lng: 114.1942,
      },
      localeBottomRight: {
        lat: 22.4083,
        lng: 114.2176,
      },
      map: {
        zoom: 0,
        center: {
          lat: 0,
          lon: 0
        },
        bounds:{
          ul:{
            lat: 0,
            lon: 0
          },
          br:{
            lat: 0,
            lon: 0
          }
        },
        style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
        _style: "cartoon",
        lang: "zh"
      },
      routeData: null,
      localeData: null,
      localeColor:this.props.theme.palette.primary.main,
      route: [],
    }
    autoBind(this);
  }

  handleClose() {
    this.setState({
      open: false
    });
    this.state.open = false;
  }

  distance(lat1, lon1, lat2, lon2, unit = "K") {
    if ((lat1 == lat2) && (lon1 == lon2)) {
      return 0;
    }
    else {
      var radlat1 = Math.PI * lat1/180;
      var radlat2 = Math.PI * lat2/180;
      var theta = lon1-lon2;
      var radtheta = Math.PI * theta/180;
      var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = dist * 180/Math.PI;
      dist = dist * 60 * 1.1515;
      if (unit=="K") { dist = dist * 1.609344 }
      if (unit=="N") { dist = dist * 0.8684 }
      return dist;
    }
  }
  // routeFilter (a 10 m decimator) is GONE: it was the composer's own
  // invention and had no counterpart in the app, so it was one of the reasons
  // the two views disagreed. flutterRoutePipeline reproduces the app's
  // outlier/smoothing/stationary stages instead.

  genBoxData(){
    var boxData = []
    boxData.push({
      'type': 'Feature',
      'color': parseInt(this.state.localeColor).toString(16),
      'geometry': {
        'type': 'Polygon',
        'coordinates': [[
          [parseFloat(this.state.localeUpperLeft.lng), parseFloat(this.state.localeUpperLeft.lat)],
          [parseFloat(this.state.localeUpperLeft.lng), parseFloat(this.state.localeBottomRight.lat)],
          [parseFloat(this.state.localeBottomRight.lng), parseFloat(this.state.localeBottomRight.lat)],
          [parseFloat(this.state.localeBottomRight.lng), parseFloat(this.state.localeUpperLeft.lat)],
          [parseFloat(this.state.localeUpperLeft.lng), parseFloat(this.state.localeUpperLeft.lat)]
        ]]
      }
    });
    
    var boxLayers = new GeoJsonLayer({
        id: 'geojson-layer',
        data: boxData,
        lineWidthScale: 4,
        opacity: 0.4,
        filled: true,
        stroked: true,
        lineWidth: 2,
        lineWidthMinPixels: 2,
        wireframe: true,
        getLineColor: f => {
          var hex = f.color;
          while(hex.length != 6){
            hex = '0' + hex;
          }
          // convert to RGB
          return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0];
        },
        getFillColor: f => {
          var hex = f.color;
          while(hex.length != 6){
            hex = '0' + hex;
          }
          hex = hex + '1f';
          // convert to RGB
          return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 0];
        },
        pickable: true,
      });

      return boxLayers;
  }

  genRouteData(routeData, outline = false){
    // append routeArr here
    var routeArr = [];
    if (routeData != null){
      for (let i = 0; i < routeData.length; i++){
        routeArr.push([routeData[i][0], routeData[i][1]]); 
      }
    }
    
    var routeData = []
    routeData.push({
      'type': 'Feature',
      'color': parseInt(this.state.localeColor).toString(16),
      'geometry': {
        'type': 'Polygon',
        'coordinates': [routeArr]
      }
    });
    
    if (outline){
      var routeLayers = new GeoJsonLayer({
        id: 'geojson-layer',
        data: routeData,
        lineWidthScale: 2,
        opacity: 1,
        filled: false,
        stroked: true,
        lineWidth: 2,
        lineWidthMinPixels: 2,
        lineCapRounded: true,
        lineJointRounded: true,
        // wireframe: true,
        getLineColor: f => {
          return [255, 255, 255];
        },
        
        pickable: true,
      });
    }else{
      var routeLayers = new GeoJsonLayer({
        id: 'geojson-layer',
        data: routeData,
        lineWidthScale: 1,
        opacity: 0.5,
        filled: false,
        stroked: true,
        lineWidth: 2,
        lineWidthMinPixels: 2,
        lineCapRounded: true,
        lineJointRounded: true,
        // wireframe: true,
        getLineColor: f => {
          var hex = f.color;
          while(hex.length != 6){
            hex = '0' + hex;
          }
          // convert to RGB
          return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0];
        },
        
        pickable: true,
      });
    }

    return routeLayers
  }


  // ---------------------------------------------------------------------------
  // ex_flutterv1's route-history pipeline, ported verbatim so this dialog and
  // the app draw the SAME thing. Source: ex_flutterv1/lib/features/map/
  // route_history_screen.dart — constants at :19-34, stages at :565-585.
  //
  // Order matters and is the app's: bounds clip -> outlier removal ->
  // segmentation -> smoothing -> >=2 points -> stationary-cluster deletion ->
  // >=2 points AND >=70 m endpoint displacement.
  //
  // NOTE ON WHAT THIS COSTS. The stationary filter deletes any run of >=4
  // samples spanning >=20 s whose path stays inside 30 m. At the app's 5 s
  // sampling that is any pace under ~1.5 m/s — i.e. ordinary walking (1.2-1.4
  // m/s). On locale 283 / 2026-07-20 it removes 30-90% of every track, and the
  // 70 m endpoint rule then discards whole walks that happen to loop back:
  // 7 of those 20 submissions end up drawing NOTHING. That is the app's
  // behaviour and matching it was the point; the numbers are here so nobody
  // later reads the empty map as a bug in this dialog.
  // ---------------------------------------------------------------------------

  /** Metres between two [lat, lon] points (RoutePoint.distanceTo). */
  metresBetween(a, b) {
    const R = 6371000.0;
    const rad = Math.PI / 180;
    const dLat = (b[0] - a[0]) * rad;
    const dLon = (b[1] - a[1]) * rad;
    const h = Math.sin(dLat / 2) * Math.sin(dLat / 2)
      + Math.cos(a[0] * rad) * Math.cos(b[0] * rad) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
  }

  median(values) {
    if (values.length === 0) return 0;
    const sorted = [...values].sort((x, y) => x - y);
    const mid = Math.floor(sorted.length / 2);
    return (sorted.length % 2 === 1) ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2;
  }

  /** _filterPointsByBounds — epack bbox, padded for GPS noise. */
  flutterBoundsClip(points) {
    const ul = this.state.localeUpperLeft;
    const br = this.state.localeBottomRight;
    const pad = 0.0005;
    const ulLat = parseFloat(ul && ul.lat);
    const ulLon = parseFloat(ul && ul.lng);
    const brLat = parseFloat(br && br.lat);
    const brLon = parseFloat(br && br.lng);
    if ([ulLat, ulLon, brLat, brLon].some((v) => isNaN(v))) {
      return points; // no bounds configured — the app returns the list unfiltered
    }
    const minLat = Math.min(ulLat, brLat) - pad;
    const maxLat = Math.max(ulLat, brLat) + pad;
    const minLon = Math.min(ulLon, brLon) - pad;
    const maxLon = Math.max(ulLon, brLon) + pad;
    return points.filter((p) => p[0] >= minLat && p[0] <= maxLat && p[1] >= minLon && p[1] <= maxLon);
  }

  /** _removeOutliers — median/MAD modified z-score on per-segment speed. */
  flutterRemoveOutliers(points) {
    if (points.length <= 2) return points;
    const HARD_SPEED_CAP = 120.0;
    const MAX_GAP_DISTANCE = 190.0;
    const Z_THRESHOLD = 4.6;
    const MIN_SEGMENT_DISTANCE = 2.0;

    const segments = [];
    const validSpeeds = [];
    for (let i = 0; i < points.length - 1; i++) {
      // Dart's DateTime.difference().inSeconds TRUNCATES; the stored timestamps
      // carry millisecond fractions, so truncate here too or the speeds differ.
      const duration = Math.trunc(points[i + 1][2]) - Math.trunc(points[i][2]);
      const distance = this.metresBetween(points[i], points[i + 1]);
      const speed = (duration > 0) ? (distance / duration) : Infinity;
      const seg = {
        endIndex: i + 1,
        speed: speed,
        distance: distance,
        validDuration: duration > 0,
        meaningful: distance >= MIN_SEGMENT_DISTANCE,
      };
      segments.push(seg);
      if (seg.validDuration && seg.meaningful && isFinite(speed) && speed > 0 && speed < HARD_SPEED_CAP) {
        validSpeeds.push(speed);
      }
    }
    if (segments.length === 0 || validSpeeds.length < 3) return points;

    const medianSpeed = this.median(validSpeeds);
    const mad = this.median(validSpeeds.map((v) => Math.abs(v - medianSpeed)));
    const denominator = (mad < 1e-6) ? Math.max(1.0, medianSpeed * 0.1) : mad;

    const outliers = new Set();
    const isInterior = (idx) => idx !== 0 && idx !== points.length - 1;
    segments.forEach((seg) => {
      if (!seg.validDuration) {
        if (isInterior(seg.endIndex)) outliers.add(seg.endIndex);
        return;
      }
      if (!seg.meaningful) return;
      if (seg.speed >= HARD_SPEED_CAP || seg.distance >= MAX_GAP_DISTANCE * 3) {
        if (isInterior(seg.endIndex)) outliers.add(seg.endIndex);
        return;
      }
      const modifiedZ = 0.6745 * (seg.speed - medianSpeed) / denominator;
      if (Math.abs(modifiedZ) > Z_THRESHOLD && isInterior(seg.endIndex)) {
        outliers.add(seg.endIndex);
      }
    });
    if (outliers.size === 0) return points;
    return points.filter((_, i) => !(isInterior(i) && outliers.has(i)));
  }

  /** _segmentRoutes — split on a timestamp anomaly, a 190 m jump or a 600 s gap. */
  flutterSegment(points) {
    if (points.length === 0) return [];
    if (points.length === 1) return [points];
    const MAX_GAP_DISTANCE = 190.0;
    const MAX_GAP_TIME = 600.0;
    const routes = [];
    let current = [points[0]];
    for (let i = 1; i < points.length; i++) {
      const distance = this.metresBetween(points[i], points[i - 1]);
      const timeDiff = Math.trunc(points[i][2]) - Math.trunc(points[i - 1][2]);
      // invalidTime is <= 0, so the app also splits on EQUAL timestamps, which
      // this data is full of (the 5 s poll re-inserting an unchanged fix).
      if (timeDiff <= 0 || distance > MAX_GAP_DISTANCE || timeDiff > MAX_GAP_TIME) {
        if (current.length > 0) routes.push(current);
        current = [points[i]];
        continue;
      }
      current.push(points[i]);
    }
    if (current.length > 0) routes.push(current);
    return routes;
  }

  /** _smoothRoute — 3-point moving average over the interior. */
  flutterSmooth(points) {
    if (points.length <= 2) return points;
    const smoothed = [points[0]];
    for (let i = 1; i < points.length - 1; i++) {
      smoothed.push([
        (points[i - 1][0] + points[i][0] + points[i + 1][0]) / 3,
        (points[i - 1][1] + points[i][1] + points[i + 1][1]) / 3,
        points[i][2],
      ]);
    }
    smoothed.push(points[points.length - 1]);
    return smoothed;
  }

  /** _filterStationaryClusters — deletes the whole cluster, anchor included. */
  flutterStationaryFilter(route) {
    const RADIUS = 30.0;
    const MIN_SAMPLES = 4;
    const MIN_DURATION = 20;
    const kept = [];
    let i = 0;
    while (i < route.length) {
      let j = i + 1;
      let cumulative = 0;
      while (j < route.length) {
        cumulative += this.metresBetween(route[j - 1], route[j]);
        const displacement = this.metresBetween(route[i], route[j]);
        if (cumulative <= RADIUS && displacement <= RADIUS) { j++; continue; }
        break;
      }
      const clusterSize = j - i;
      const duration = Math.trunc(route[j - 1][2]) - Math.trunc(route[i][2]);
      if (clusterSize >= MIN_SAMPLES && duration >= MIN_DURATION) {
        i = j; // the app drops every point of the cluster, the anchor too
        continue;
      }
      kept.push(route[i]);
      i += 1;
    }
    return kept;
  }

  /**
   * The whole app pipeline. Returns sub-routes of [lat, lon, ts] points, still
   * in stored order — genPathLayer swaps them for GeoJSON.
   */
  flutterRoutePipeline(routeData) {
    if (!Array.isArray(routeData) || routeData.length === 0) return [];
    const MIN_DISPLAY_DISTANCE = 70.0;

    const inBounds = this.flutterBoundsClip(routeData);
    if (inBounds.length < 2) return [];

    const base = this.flutterSegment(this.flutterRemoveOutliers(inBounds))
      .map((route) => this.flutterSmooth(route))
      .filter((route) => route.length >= 2);

    return base
      .map((route) => this.flutterStationaryFilter(route))
      .filter((route) => route.length >= 2)
      .filter((route) => this.metresBetween(route[0], route[route.length - 1]) >= MIN_DISPLAY_DISTANCE);
  }

  genPathLayer(){
    var pathLayers = [];
    if (this.state.routeData != null){
      // Segmentation, outlier removal, smoothing and the stationary/short-route
      // gates are ALL the app's now (flutterRoutePipeline), so the two views
      // agree. The composer's own 300 s-only split and 10 m decimator are gone
      // — they were what made this dialog show more of the walk than the app.
      var subRoutes = this.flutterRoutePipeline(this.state.routeData);

      for(let i = 0; i < subRoutes.length; i++){
        // Stored order is [lat, lon, ts]; GeoJSON wants [lon, lat].
        var filtered_route = subRoutes[i].map((p) => [p[1], p[0]]);

        pathLayers.push(this.genRouteData(filtered_route, true));
        pathLayers.push(this.genRouteData(filtered_route, false));

        if(filtered_route[0][0] != filtered_route[filtered_route.length-1][0] || filtered_route[0][1] != filtered_route[filtered_route.length-1][1]){
          pathLayers.push(this.genIconLayer(true, filtered_route[0]));
          pathLayers.push(this.genIconLayer(false, filtered_route[filtered_route.length-1]));
        }
      }
    }

    return pathLayers;
  }

  genIconLayer(start = true, coordinate){
    var iconData = [];
    var iconA = null;

    if (this.state.routeData != null){
      if (start){
        iconData.push({
          'color': '00ff00',
          'coordinates': coordinate,
        });
        iconA = startFlag;
      }else{
        iconData.push({
          'color': 'ff0000',
          'coordinates': coordinate,
        });
        iconA = endFlag;
      }
    }

    const ICON_MAPPING = {
      marker: {
        x: 0,
        y: 0,
        width: 80,
        height: 80,
        anchorY: 80,
        mask: true
      }
    };

    var iconLayers = new IconLayer({
      id: 'icon-layer',
      data: iconData,
      pickable: true,
      autoHighlight: false,
      iconAtlas: iconA,
      iconMapping: ICON_MAPPING,
      getIcon: d => 'marker',
  
      sizeScale: 15,
      getPosition: d => d.coordinates,
      getSize: d => 3,
      getColor: f => {
        var hex = f.color;
        while(hex.length != 6){
          hex = '0' + hex;
        }
        // convert to RGB
        return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 0];
      },
    });

    return iconLayers;
  }

  setRouteData(data) {
    this.setState({ routeData: data });
    let pointArr = [];
    for(let i = 0; i < data.length; i++) {
      let point = {
        lat: data[i][0],
        lng: data[i][1],
      }
      pointArr.push(point);
    }
    this.setState({ route: pointArr });

    let localeData = this.props.root.getCurrentLocale();
    this.setState({
      localeCenter: {lat: parseFloat(localeData.mid_lat), lng: parseFloat(localeData.mid_lon)},
      localeUpperLeft: {lat: parseFloat(localeData.ul_lat), lng: parseFloat(localeData.ul_lon)},
      localeBottomRight: {lat: parseFloat(localeData.br_lat), lng: parseFloat(localeData.br_lon)},
      localeColor: localeData.color,
    });
  }

  render() {
    
    let localeCenter = this.state.localeCenter;
    
    const initialViewState = {
      longitude: localeCenter.lng,
      latitude: localeCenter.lat,
      zoom: 15
    };

    const {viewstate, map} = this.state;
    const boxLayers = this.genBoxData();
    // const routeLayers = this.genRouteData(false);
    // const routeOutlineLayers = this.genRouteData(true);
    // const iconStartLayers = this.genIconLayer(true);
    // const iconEndLayers = this.genIconLayer(false);
    const pathLayers = this.genPathLayer();

    return (
      <Dialog
        open={this.state.open}
        onClose={this.handleClose}
        fullWidth={true}
        fullHeight={true}
        maxWidth={'lg'}
      >
        <DialogContent>
          <div style={{position:"relative", height:'70vh'}}>
            <DeckGL 
              initialViewState={initialViewState} 
              // viewState={viewState}
              controller={true} height='100%'
              top="50px" position="relative" 
              layers={[boxLayers].concat(pathLayers)}//, routeOutlineLayers, routeLayers, iconStartLayers, iconEndLayers]}
            >
          
                <Map mapStyle={map.style} mapboxAccessToken={Config.MBOX_KEY()} attributionControl={false}/>
                <ButtonGroup style={{top:10, left:10, position:"relative"}} size="small" variant="contained" color="primary" aria-label="contained primary button group">
                  <Button color={this.state.map._style=="mono"? "secondary":"primary"} onClick={
                    () => {
                      this.setState({
                        map:{
                          ...this.state.map,
                          style: Config.MBOX_STYLE(Localization.strings.getLanguage()).mono,
                          _style: "mono"
                        }
                      });
                      this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).mono;
                      this.state.map._style = "mono";
                    }
                  }>{Localization.strings.MAP_MONO}</Button>
                  <Button color={this.state.map._style=="satellite"? "secondary":"primary"} onClick={
                    () => {
                      this.setState({
                        map:{
                          ...this.state.map,
                          style: Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite,
                          _style: "satellite"
                        }
                      });
                      this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite;
                      this.state.map._style = "satellite";
                    }
                  }>{Localization.strings.MAP_SATELLITE}</Button>
                  <Button color={this.state.map._style=="cartoon"? "secondary":"primary"} onClick={
                    () => {
                      this.setState({
                        map:{
                          ...this.state.map,
                          style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
                          _style: "cartoon"
                        }
                      });
                      this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon;
                      this.state.map._style = "cartoon";
                    }
                  }>{Localization.strings.MAP_VECTOR}</Button>
                </ButtonGroup>
            </DeckGL>
          </div>
        </DialogContent>
        <DialogActions style={{padding:'16px 24px'}}>
          <Button onClick={this.handleClose}>
            {Localization.strings.CLOSE}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withTheme(SubmissionDetailMapDialog);
